var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.333252 18.3334C0.333252 14.6515 3.31802 11.6667 6.99992 11.6667C10.6818 11.6667 13.6666 14.6515 13.6666 18.3334H11.9999C11.9999 15.572 9.76134 13.3334 6.99992 13.3334C4.23849 13.3334 1.99992 15.572 1.99992 18.3334H0.333252ZM6.99992 10.8334C4.23742 10.8334 1.99992 8.59587 1.99992 5.83337C1.99992 3.07087 4.23742 0.833374 6.99992 0.833374C9.76242 0.833374 11.9999 3.07087 11.9999 5.83337C11.9999 8.59587 9.76242 10.8334 6.99992 10.8334ZM6.99992 9.16671C8.84159 9.16671 10.3333 7.67504 10.3333 5.83337C10.3333 3.99171 8.84159 2.50004 6.99992 2.50004C5.15825 2.50004 3.66659 3.99171 3.66659 5.83337C3.66659 7.67504 5.15825 9.16671 6.99992 9.16671Z",
    fill: "#2F3444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickLogin);
export default __webpack_public_path__ + "static/media/quick-login.3f0bb928f2ae825f7a944ef489dbec9f.svg";
export { ForwardRef as ReactComponent };